<template>
  <central-modal
    id="create-category-modal"
    :modalClass="'ModalBox--medium'"
    @close="emitClose()"
  >
    <template slot="header">
      <div class="Tit Tit--modal w-100">
        {{$t(headerTitle)}}
      </div>
    </template>
    <template slot="content">
      <div class="d-flex flex-column">

        <label
          for=""
          class="form--label u-required"
        >{{$t('company_details_create_category_category_name').toUpperCase()}}</label>
        <div class="Form-field mx-0">
          <input
            type="text"
            class="Input-text"
            v-model="categoryForm.name"
            :placeholder="$t('company_details_create_category_category_name')"
          >

        </div>
        <div class="mt-3">
          <span class="">{{$t('company_details_create_category_category_color')}}</span>
          <div class="d-flex flex-row flex-grow-1 flex-wrap">

            <color-selector
              v-for="color in categoryColors"
              :key="color"
              class="mx-1"
              :color="color"
              @emitColor="setCategoryColor"
              :selected="categoryForm.color === color"
            />

          </div>
        </div>
        <div class="mt-4">
          <button
            class="Fuell-Button blue w-100"
            :class="{'disabled' : !canBeSubmitted}"
            :disabled="!canBeSubmitted"
            @click="handleSubmit"
          >
            {{$t(submitButtonLabel)}}
          </button>
        </div>

      </div>

    </template>

  </central-modal>

</template>

<script>
import CentralModal from '@/components/Commons/Modals/CentralModal'
import ColorSelector from '@/components/Commons/Forms/ColorSelector'
import { categoryColors } from '../../_constants/categoryConstants'

const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')

export default {
  name: 'CreateCategoryModal',
  components: { CentralModal, ColorSelector },
  mixins: [validationMixin],
  props: {
    category: {
      type: [Object, Boolean]
    }
  },
  data () {
    return {
      categoryForm: {
        name: '',
        color: ''
      }

    }
  },
  methods: {

    emitClose () {
      this.categoryForm.name = ''
      this.categoryForm.color = ''

      this.$emit('close')
    },
    setCategoryColor (event) {
      this.categoryForm.color = event
    },
    handleSubmit () {
      if (this.category?.id) {
        this.editCategory()
      } else {
        this.createCategory()
      }
    },

    async createCategory () {
      await this.$store.dispatch('CategoriesStore/createCategory', this.categoryForm)
      this.emitClose()
    },
    async editCategory () {
      await this.$store.dispatch('CategoriesStore/updateCategory', { id: this.category.id, data: this.categoryForm })
      this.emitClose()
    }

  },
  computed: {
    canBeSubmitted () {
      return !this.$v.$invalid
    },
    categoryColors () {
      return categoryColors
    },
    headerTitle () {
      return this.category?.id ? 'company_details_edit_category_title' : 'company_details_new_category_title'
    },
    submitButtonLabel () {
      return this.category?.id ? 'company_details_edit_category_action' : 'company_details_create_category_create_category_action'
    }
  },
  created () {
    if (this.category?.id) {
      this.categoryForm.name = this.category.name
      this.categoryForm.color = this.category.color
    }
  },

  validations: {
    categoryForm: {
      name: { required: required },
      color: { required: required }
    }

  }

}
</script>

<style scoped>
.Tit--modal {
  margin-left:0px!important;
}
</style>
